<template>
  <nav class="navbar is-fixed-top" id="navbar">
    <div class="navbar-brand">
      <a @click.native="showNav=false" :href="$_config.BASE_URL" class="navbar-item logo">
        <!-- <img src="../assets/img/logo-roofs.png" width="240px" alt="КРЕДИТ, КОГАТО Е СПЕШНО!"> -->
        <!-- <img src="../assets/img/logo-3-houses-10.png" width="222px" height="31px" alt="КРЕДИТ, КОГАТО Е СПЕШНО!"> -->
        <img
          src="../assets/img/logo-3-houses-cc3300-330px.png"
          width="222px"
          height="31px"
          alt="КРЕДИТ, КОГАТО Е СПЕШНО!"
        >
      </a>
      <div
        class="navbar-burger burger"
        @click.prevent="showNav = !showNav"
        :class="{ 'is-active': showNav }"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': showNav }">
      <div class="navbar-start"></div>

      <div @click.prevent="showNav = !showNav" class="navbar-end has-text-left">
        <!-- <router-link @click.native.prevent="showNav=false" class="navbar-item"
        tag="a" to="/">Начало</router-link>-->
        <a @click.prevent="$eventBus.scrollTo('navbar')" class="navbar-item">Начало</a>
        <a @click.prevent="$eventBus.scrollTo('products')" class="navbar-item">Кредит</a>
        <a @click.prevent="$eventBus.scrollTo('why', -45)" class="navbar-item">Защо</a>
        <a @click.prevent="$eventBus.scrollTo('how')" class="navbar-item">Как</a>
        <!-- <a @click.prevent="$eventBus.scrollTo('p-plans')" class="navbar-item">План</a> -->
        <a @click.prevent="$eventBus.scrollTo('about')" class="navbar-item">За нас</a>
        <!-- <a @click.prevent="$eventBus.scrollTo('powers')" class="navbar-item">Предимства</a> -->
        <a @click.prevent="$eventBus.scrollTo('footer')" class="navbar-item">Инфо</a>

        <!-- <router-link class="navbar-item" to="#home">Старт</router-link>
        <router-link class="navbar-item" to="#products">Кредит</router-link>
        <router-link class="navbar-item" to="#powers">Защо</router-link>
        <router-link class="navbar-item" to="#powers">Как</router-link>
        <router-link class="navbar-item" to="#p-plans">План</router-link>
        <router-link class="navbar-item" to="#about">Ние</router-link>
        <router-link class="navbar-item" to="#footer">Инфо</router-link>-->
        <div class="navbar-item">
          <div class="field is-grouped">
            <p class="control">
              <a
                @click.prevent="$eventBus.scrollTo('application-form')"
                class="button is-rounded is-outlined navbar-item"
              >
                <strong>ВЗЕМИ ИПОТЕЧЕН КРЕДИТ</strong>
              </a>
            </p>
          </div>
        </div>

        <a href="tel:070011755" class="phone navbar-item has-text-info">
          <i class="fas fa-phone"></i>
          &nbsp;
          0700 11-7-55
        </a>
      </div>
    </div>
  </nav>

  <!-- </div> -->
</template>

<script>

export default {
  name: 'Navbar',
  data () {
    return {
      showNav: false,
      path: null,
      anchor: null
    }
  }
  // methods: {
  //   navTo (path, anchor) {
  //     this.$router.push(path + '#' + anchor)
  //     // this.$eventBus.loadLazy(() => {
  //     //   this.$scrollTo('#' + anchor, 500, {offset: -32})
  //     // })
  //   }
  // }
}
</script>

<style lang='stylus' scoped>
.navbar {
  border-bottom: 1px solid lightgray;
}

a.navbar-item {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 16px; // 22px

  &.phone {
    font-weight: 700;
    font-size: 24px;
  }
}

.navbar-item img {
  max-height: 100%;
}

// a:not(.router-link-exact-active):hover
// border-bottom: solid 3px lightgrey
.router-link-exact-active {
  background-color: #fafafa;
  color: #cc3300;
}

a.logo {
  padding: 0.75rem 0.75rem 0.5rem 0.75rem;
}

a.navbar-item:hover {
  background: #fafafa;
  // color: #cc3300
  color: #43a2e6;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue